import { DateTime, Interval } from 'luxon';

const useShortenedRelativeTime = (timestamp: string): string | null => {
  const timeOfUpdate = DateTime.fromISO(timestamp);
  const currentTime = DateTime.now();
  const diff = Interval.fromDateTimes(timeOfUpdate, currentTime);
  const diffMins = diff.length('minutes');
  const diffHours = diff.length('hours');
  const diffDays = diff.length('days');
  const diffWeeks = diff.length('weeks');

  let lastKnownRelativeTime = 'Now';
  switch (true) {
    // weeks
    case diffWeeks > 1:
      lastKnownRelativeTime = `${Math.floor(diffWeeks)}w`;
      break;
    // days
    case diffDays > 1:
      lastKnownRelativeTime = `${Math.floor(diffDays)}d`;
      break;
    // hours
    case diffHours > 1:
      lastKnownRelativeTime = `${Math.floor(diffHours)}h`;
      break;
    // minutes
    case diffMins > 1:
      lastKnownRelativeTime = `${Math.floor(diffMins)}m`;
      break;
    // less than a minute
    default:
      lastKnownRelativeTime = 'Now';
      break;
  }

  return lastKnownRelativeTime;
};

export default useShortenedRelativeTime;
